import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavLink {
  to: string;
  label: string;
  match: string;
}

const INTERNAL_LINKS: NavLink[] = [
  { to: '/login', label: 'LOGIN', match: '/login' },
];

export default function PromoHeader() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isContact = location.pathname === '/contact';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`promo-navbar${scrolled || open ? ' scrolled' : ''}`}>
      <Link to="/">
        <img src="/assets/images/GC-Logo-White.svg" alt="GGContent" className="logo" />
      </Link>

      <div className={`nav-links${open ? ' open' : ''}`}>
        {INTERNAL_LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className={location.pathname === l.match ? 'active' : ''}
            onClick={() => setOpen(false)}
          >
            {l.label}
          </Link>
        ))}
      </div>

      <div className="mobile-toggle" onClick={() => setOpen(!open)}>
        <svg width="18" height="12" viewBox="0 0 18 12" fill="var(--vivid-green)">
          {open ? (
            <>
              <line x1="1" y1="1" x2="17" y2="11" stroke="var(--vivid-green)" strokeWidth="2" />
              <line x1="1" y1="11" x2="17" y2="1" stroke="var(--vivid-green)" strokeWidth="2" />
            </>
          ) : (
            <>
              <rect y="0" width="18" height="2" />
              <rect y="5" width="18" height="2" />
              <rect y="10" width="18" height="2" />
            </>
          )}
        </svg>
      </div>

      {!isContact && (
        <div className="request-demo-fixed">
          <Link to="/contact" className="btn-gc" style={{ fontSize: 12, padding: '10px 20px' }}>
            <span style={{ marginRight: 6 }}>&raquo;</span>Request demo
          </Link>
        </div>
      )}
    </nav>
  );
}
